(function () {
    'use strict';
    /*
     * Copyright (c) 2016-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhFullscreenButton', ihhFullscreenButton);

    function ihhFullscreenButton () {
        var link = function (scope, elem, attrs, API) {
            scope.onClickFullscreenCustom = function () {
                scope.API = API;
                scope.API.toggleFullScreen(); //finishes in its own time
            };
        };

        return {
            restrict: 'E',
            require: '^videogular',
            template: '<button class="iconButton" ng-click="onClickFullscreenCustom()" aria-label="Toggle Fullscreen" type="button"><span class="glyphicon glyphicon-fullscreen"></span></button>',
            link: link
        };
    }
})();